import FormHeader from '../components/layout/FormHeader';
import FormFooter from '../components/layout/FormFooter';

interface LayoutFormProps {
  children: React.ReactNode;
}

const FormPage: React.FC<LayoutFormProps> = ({ children }) => (
  <>
    <FormHeader />
    <main>{children}</main>
    <FormFooter />
  </>
);
 
export default FormPage;